import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "deactivateModal",
    "deleteModal",
    "deleteConfirmationInput",
    "confirmDeleteButton",
  ];

  static values = { userPath: String };

  confirmDeactivate() {
    this.deactivateModalTarget.classList.remove("hidden");
  }

  closeDeactivate() {
    this.deactivateModalTarget.classList.add("hidden");
  }

  executeDeactivate() {
    this.submitForm("PATCH", { "user[status]": "deactivated" });
  }

  confirmDelete() {
    this.deleteModalTarget.classList.remove("hidden");
    this.deleteConfirmationInputTarget.focus();
  }

  closeDelete() {
    this.deleteModalTarget.classList.add("hidden");
    this.deleteConfirmationInputTarget.value = "";
    this.toggleDeleteButton();
  }

  toggleDeleteButton() {
    const input = this.deleteConfirmationInputTarget;
    const button = this.confirmDeleteButtonTarget;

    if (input.value === "DELETE") {
      button.disabled = false;
      button.classList.remove("opacity-50", "cursor-not-allowed");
    } else {
      button.disabled = true;
      button.classList.add("opacity-50", "cursor-not-allowed");
    }
  }

  executeDelete() {
    if (this.deleteConfirmationInputTarget.value !== "DELETE") {
      alert('Please type "DELETE" to confirm');
      return;
    }
    this.submitForm("DELETE", {});
  }

  deactivateInstead() {
    this.closeDelete();
    this.confirmDeactivate();
  }

  closeOnBackdrop(event) {
    if (
      event.target === this.deactivateModalTarget ||
      event.target === this.deleteModalTarget
    ) {
      this.deactivateModalTarget.classList.add("hidden");
      this.deleteModalTarget.classList.add("hidden");
      this.deleteConfirmationInputTarget.value = "";
      this.toggleDeleteButton();
    }
  }

  submitForm(method, params) {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = this.userPathValue;

    const methodInput = document.createElement("input");
    methodInput.type = "hidden";
    methodInput.name = "_method";
    methodInput.value = method;
    form.appendChild(methodInput);

    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content");
    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = "authenticity_token";
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);

    Object.entries(params).forEach(([name, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }
}
